import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

function Header({ children, dragging, onMouseDown }) {
  return (
    <div
      className={cns(
        'modal--header',
        {
          'modal--dragging': dragging,
        },
      )}
      onMouseDown={onMouseDown}
      role="presentation"
    >
      {children}
    </div>
  );
}

Header.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Assegna la classe dragging al componente
     * @ignore
     */
  dragging: PropTypes.bool,
  /** Callback invocata alla pressione del mouse
     * @ignore
     */
  onMouseDown: PropTypes.func,
};

Header.defaultProps = {
  children: null,
  dragging: false,
  onMouseDown: null,
};

export default Header;
